module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Sun-glasses-c6669f8ba30f1e758b9be15debb2cf8c.svg";